/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/29
 * @Version : 1.0
 * @Content : 公用组件
 */
import BIcon from '@/components/BIcon'
import Vue from 'vue'

Vue.component('BIcon', BIcon)
